import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarPlus, faChartBar, faPlus, faCog } from '@fortawesome/free-solid-svg-icons';

const QuickActions: React.FC = () => {
  return (
    <section id="quick-actions" className="mb-8">
      <div className="backdrop-blur-xl bg-white/5 p-6 rounded-2xl border border-white/10">
        <h2 className="text-xl font-semibold text-white mb-6">Hızlı Eylemler</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <button className="p-4 bg-gradient-to-br from-purple-600/20 to-purple-400/10 border border-purple-400/20 rounded-xl hover:from-purple-600/30 hover:to-purple-400/20 transition-all group">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-400 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <FontAwesomeIcon icon={faCalendarPlus} className="text-black" />
              </div>
              <div className="text-left">
                <h4 className="text-white font-medium">Paylaşım Planla</h4>
                <p className="text-white/50 text-sm">İçeriğini planla</p>
              </div>
            </div>
          </button>

          <button className="p-4 bg-gradient-to-br from-blue-600/20 to-blue-400/10 border border-blue-400/20 rounded-xl hover:from-blue-600/30 hover:to-blue-400/20 transition-all group">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-400 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <FontAwesomeIcon icon={faChartBar} className="text-black" />
              </div>
              <div className="text-left">
                <h4 className="text-white font-medium">Rapor Oluştur</h4>
                <p className="text-white/50 text-sm">Analitiği dışa aktar</p>
              </div>
            </div>
          </button>

          <button className="p-4 bg-gradient-to-br from-green-600/20 to-green-400/10 border border-green-400/20 rounded-xl hover:from-green-600/30 hover:to-green-400/20 transition-all group">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-green-400 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <FontAwesomeIcon icon={faPlus} className="text-black" />
              </div>
              <div className="text-left">
                <h4 className="text-white font-medium">Hesap Ekle</h4>
                <p className="text-white/50 text-sm">Platform bağla</p>
              </div>
            </div>
          </button>

          <button className="p-4 bg-gradient-to-br from-pink-600/20 to-pink-400/10 border border-pink-400/20 rounded-xl hover:from-pink-600/30 hover:to-pink-400/20 transition-all group">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-pink-400 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                <FontAwesomeIcon icon={faCog} className="text-black" />
              </div>
              <div className="text-left">
                <h4 className="text-white font-medium">Ayarlar</h4>
                <p className="text-white/50 text-sm">Uyarıları yapılandır</p>
              </div>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default QuickActions;
